<template>
  <div style="background: #f4f4f4">
    <van-list
      v-if="dataArr.length > 0"
      v-model="isLoading"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :finished="hasMore"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="card-box" v-for="(item, index) in dataArr" :key="index">
        <card :rowData="item" :status="status"></card>
      </div>
    </van-list>
    <div class="noPackage" v-if="dataArr.length == 0 && !loading">
      <img
        src="../../../assets/img/myPackage/noPackage.png"
        style="width: 2rem"
        alt="暂无包裹"
      />
      <p style="text-align: center; margin-top: 0.32rem">无包裹信息</p>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import card from "./card";
export default {
  name: "listView",
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      dataArr: [],
      isLoading: false,
      error: false,
      hasMore: false,
    };
  },
  computed: {
    ...mapGetters({ loading: "getLoading" }),
  },
  props: {
    status: {
      type: Number,
    },
  },
  components: {
    card,
  },
  mounted() {
    if (window._dhbridge) {
      window.dhsdk.onListenEvent("bindAddress", this.bindAddressTip);
    }
    this.getData();
  },
  methods: {
    ...mapMutations({
      changeLoading: "changeLoading",
    }),
    getFamilyMainId() {
      let that = this;
      return new Promise((resolve, reject) => {
        window.dhsdk.getFamilyMainId({
          success: (res) => {
            console.log(res, "8989");
            resolve(res.familyMainId);
          },
          fail: () => {
            that.$toast("添加失败，请联系客服！");
            reject("");
          },
        });
      });
    },
    //客户端调用此方法，激发确认弹框
    bindAddressTip: function (obj) {
      this.changeLoading(true);
      this.$api.my
        .addressTip({
          orderId: obj.data.orderId,
          enrollId: obj.data.enrollId,
        })
        .then((res) => {
          this.changeLoading(false);
          if (res.ret) {
            this.$dialog
              .confirm({
                title: "提示",
                message: res.data.tip,
              })
              .then(() => {
                // 调用绑定方法
                this.bindAddress(
                  obj.data.orderId,
                  obj.data.enrollId,
                  obj.data.addressId
                );
              });
          } else {
            this.$toast(res.msg);
          }
        });
    },
    // 绑定地址
    async bindAddress(orderId, enrollId, addrId) {
      this.changeLoading(true);
      let primaryStudentId = await this.getFamilyMainId();
      console.log(primaryStudentId, "8989");
      this.$api.my
        .saveAddress({
          orderId: orderId,
          enrollId: enrollId,
          addrId: addrId,
          primaryStudentId: primaryStudentId,
        })
        .then((res) => {
          this.changeLoading(false);
          if (res.ret) {
            this.dataArr = [];
            this.getData();
          } else {
            if (res.errcode != 2) {
              this.$toast(res.msg);
            }
          }
        });
    },
    onLoad() {
      this.pageNo = this.pageNo + 1;
      this.isLoading = true;
      this.getData();
    },
    getData() {
      if (this.pageNo === 1) {
        this.changeLoading(true);
      }
      this.$api.my
        .getPackageList({
          status: this.status,
          pageSize: this.pageSize,
          offset: this.pageSize * (this.pageNo - 1),
        })
        .then((res) => {
          // res = {
          //   ret: true,
          //   msg: "操作成功",
          //   data: {
          //     offset: 0,
          //     pageSize: 10,
          //     totalRows: 100,
          //     content: [
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "课程已退课，教材资料不再寄送",
          //         productName: "初一数学寒假在线1对",
          //         subjectId: 1,
          //         subjectName: "语文",
          //         status: 10,
          //         sendBackStatus: 2,
          //         statusName: "退回成功",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "查看物流",
          //         multiplePackage: true,
          //         sendBackText: "退回教材",
          //         addAddressText: "添加收获地址",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "",
          //         productName:
          //           "初一数学寒假在线1对1班级初一数学寒假在线1对1班级学寒假在线1对1班级学寒假在线1对1班级",
          //         subjectId: 1,
          //         subjectName: "语文",
          //         status: 10,
          //         sendBackStatus: 0,
          //         statusName: "待发货",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "查看物流",
          //         multiplePackage: true,
          //         sendBackText: "退回教材",
          //         addAddressText: "添加收获地址",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "",
          //         productName:
          //           "初一数学寒假在线1对1班级初一数学寒假在线1对1班级学寒假在线1对1班级学寒假在线1对1班级",
          //         subjectId: 1,
          //         subjectName: "语文",
          //         status: 1,
          //         sendBackStatus: 0,
          //         statusName: "待发货",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "",
          //         multiplePackage: true,
          //         sendBackText: "",
          //         addAddressText: "",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "课程已退课，教材资料不再寄送",
          //         productName: "初一数学寒假在线1对",
          //         subjectId: 1,
          //         subjectName: "语文",
          //         status: 10,
          //         sendBackStatus: 2,
          //         statusName: "退回成功22",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "查看物流",
          //         multiplePackage: true,
          //         sendBackText: "退回教材",
          //         addAddressText: "添加收获地址",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "课程已退课，教材资料不再寄送",
          //         productName: "初一数学寒假在线1对",
          //         subjectId: 1,
          //         subjectName: "语文",
          //         status: 1,
          //         sendBackStatus: 2,
          //         statusName: "退回成功",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "查看物流",
          //         multiplePackage: true,
          //         sendBackText: "退回教材",
          //         addAddressText: "添加收获地址",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "课程已退课，教材资料不再寄送",
          //         productName: "初一数学寒假在线1对",
          //         subjectId: 1,
          //         subjectName: "语文",
          //         status: 1,
          //         sendBackStatus: 2,
          //         statusName: "退回成功",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "查看物流",
          //         multiplePackage: true,
          //         sendBackText: "退回教材",
          //         addAddressText: "添加收获地址",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //       {
          //         bizId: "20201202160413771019000001120002",
          //         headerTip: "课程已退课，教材资料不再寄送",
          //         productName: "初一数学寒假在线1对",
          //         subjectId: 2,
          //         subjectName: "数学",
          //         status: 1,
          //         sendBackStatus: 0,
          //         statusName: "返回",
          //         goodsTitle: "教材资料 7件",
          //         goods: [
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //           {
          //             bizId: "20201202160413771019000001120003",
          //             id: "18863",
          //             name: "学习积累本",
          //           },
          //         ],
          //         logisticsText: "查看物流",
          //         multiplePackage: false,
          //         sendBackText: "退回教材",
          //         addAddressText: "添加收获地址",
          //         enrollId: "20201202160413771019000001120002",
          //         orderId: "20201202160413771019000001120002",
          //         productId: "20201202160413771019000001120002",
          //         mrbNum: "1233231313131",
          //       },
          //     ],
          //   },
          //   errcode: 0,
          // };
          this.changeLoading(false);
          if (!res.ret) {
            console.log("qqqq", res);
            this.$toast(res.msg);
            return;
          }
          let dataList = res.data.content;
          let dataArr = this.dataArr.concat(dataList); //关键代码
          this.dataArr = dataArr;
          let totalRows = res.data.totalRows;
          this.isLoading = false;
          this.hasMore = !(dataArr.length < totalRows);
          // dataSource: this.state.dataSource.cloneWithRows(dataArr), // 数据源中的数据本身是不可修改的,要更新datasource中的数据，请（每次都重新）调用cloneWithRows方法
        })
        .catch(() => {
          this.error = true;
          this.changeLoading(false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.noPackage {
  height: calc(100vh - 100px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.van-list {
  padding-top: 12px;
}
</style>
